import { twMerge } from "tailwind-merge";

import { READ_ONLY_EMPTY_BLOCK_MESSAGE } from "containers/admin/clients/client/components/form-builder/form-builder-viewer-utils";

type FormBuilderViewerEmptyStateProps = {
  className?: string;
};

const FormBuilderViewerEmptyState = ({ className }: FormBuilderViewerEmptyStateProps) => (
  <p className={twMerge("text-sm text-gray-600", className)}>
    {READ_ONLY_EMPTY_BLOCK_MESSAGE}
  </p>
);

export default FormBuilderViewerEmptyState;
